<div
  [style.height.px]="divHeight"
  (window:resize)="onResize()"
  (window:onload)="onResize()"
>
  <form>
    <div class="row">
      <div
        class="col-lg-9 text-uppercase font-weight-bold dashboard-color dashboard-cust dashboard-color-before"
      >
        Report List
      </div>
      <div class="clsicon text-right col-lg-3">
        <img
          src="assets/images/close.png"
          alt="..."
          class="img-fluid closeicon2 cursor-pointer"
          (click)="Close()"
        />
      </div>
    </div>
    <div
      class="company-table tabel-scrolling row"
      [style.height.px]="tableHeight"
    >
      <table class="table">
        <thead class="companytable fixedheader">
          <tr>
            <th scope="width-180">Report Name</th>
            <th class="width-250" scope="col">Company Name</th>
            <th class="width-150" scope="col">Site Name</th>
            <th class="width-150" scope="col">Location Name</th>
            <th class="width-300" scope="col">Meter Name</th>
          </tr>
        </thead>
        <tbody class="details">
          <tr *ngFor="let dashoarddetails of UserwiseDashBoardDetails">
            <td class="width-180">{{ dashoarddetails.DashBoardName }}</td>
            <td class="width-250">{{ dashoarddetails.CompanyName }}</td>
            <td class="width-150">{{ dashoarddetails.CompSiteName }}</td>
            <td class="width-150">{{ dashoarddetails.CompPanelName }}</td>
            <td class="width-300">{{ dashoarddetails.EnergymeterID }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>
